<div class="body-wrapper">
  <!-- <ngx-spinner></ngx-spinner> -->
  <app-open-vidu-data></app-open-vidu-data>
  <!-- <ngx-spinner bdColor = "rgba(0,0,0,0.1)" size = "medium" color = "#464343" type = "ball-spin-clockwise"></ngx-spinner> -->
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="medium" color="#fff" type="line-scale-pulse-out"
    [fullScreen]="true">
    <!-- <p style="color: white"> Please Wait... </p> -->
  </ngx-spinner>
  <router-outlet></router-outlet>
  <!-- <app-chatbot></app-chatbot> -->
  <!-- Floating Chatbot Icon -->
  <!-- <div class="chatbot-icon" (click)="openChatbot()">
    <i class="fas fa-robot"></i>
  </div> -->

  <!-- Chatbot Window -->
  <!-- <div class="chatbot-wrapper" [class.logged-in]="isChatbotLoggedIn" *ngIf="showChatbot">
    <app-chatbot [isLoggedIn]="isChatbotLoggedIn" (closeRequested)="toggleChatbot()"></app-chatbot>
  </div>
  <div class="chatbot-overlay" *ngIf="showChatbot" (click)="toggleChatbot()"></div> -->
</div>